import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import axios from "axios";

import EnhancedTable from "@shared/baseUI/EnhancedTable/EnhancedTable";
import CustomColumnFilter from "@shared/baseUI/CustomColumnFilter";

import {
  TABLE_KICKOFF_LIST,
  FILTER_TYPE_MULTI_SELECT_DROPDOWN,
  PAGE_SIZE,
  KICKOFF_LIST_ENDPOINT,
} from "@utils/constants";
import UserInfo from "@utils/UserInfo";
import "./KickOffList.scss";

const QUOTE_STATUS_LIST = {
  1: "KICK_OFF_LIST_FILTER_QUOTE_KICK_OFF_STATUS_SITE_INFO",
  2: "KICK_OFF_LIST_FILTER_QUOTE_KICK_OFF_STATUS_PO_CONSISTENCY",
  3: "KICK_OFF_LIST_FILTER_QUOTE_KICK_OFF_STATUS_SOLUTIONS_VALIDATION",
  4: "KICK_OFF_LIST_FILTER_QUOTE_KICK_OFF_STATUS_OPERATIONS_ACCEPTANCE",
  5: "KICK_OFF_LIST_FILTER_QUOTE_KICK_OFF_STATUS_COMPLETED",
};

/**
 * Component for showing KickOff List.
 * @path /kickoff/list
 * @component
 */
const KickOffList = (props) => {
  const { t } = props;
  const [koStatusOptions, setKOOptions] = useState([]);
  const [adminOptions, setAdminOptions] = useState([]);
  const countryId = UserInfo.countryId();
  const columns = [
    {
      Header: t("KICK_OFF_LIST_TABLE_QUOTE_ID"),
      accessor: "id",
      disableFilters: true,
    },
    {
      Header: t("KICK_OFF_LIST_TABLE_CLIENT_NAME"),
      accessor: "company_name",
      disableFilters: true,
    },
    {
      Header: t("KICK_OFF_LIST_TABLE_SITE_ID"),
      accessor: "jobsite_id",
      disableFilters: true,
    },
    {
      Header: t("KICK_OFF_LIST_TABLE_SITE_NAME"),
      accessor: "jobsite_name",
      disableFilters: true,
    },
    {
      Header: t("KICK_OFF_LIST_TABLE_QUOTE_AMOUNT"),
      accessor: "amount",
      disableFilters: true,
    },
    {
      Header: t("KICK_OFF_LIST_TABLE_QUOTE_MARGIN"),
      accessor: "margin",
      disableFilters: true,
    },
    {
      Header: t("KICK_OFF_LIST_TABLE_START_DATE"),
      accessor: "start_date",
      disableFilters: true,
    },
    {
      Header: t("KICK_OFF_LIST_TABLE_KO_QUOTE_STATUS"),
      accessor: "ko_status",
      Filter: (filterProps) => (
        <CustomColumnFilter
          type={FILTER_TYPE_MULTI_SELECT_DROPDOWN}
          label={t("ADMIN_LEAD_LIST_FILTER_STATUS")}
          name="kick-off-status"
          labelClass="kick-off-list__ko-status-label"
          containerClass="kick-off-list__ko-status-dropdown-container"
          inputClass=""
          placeholder={t("SEARCH")}
          defaultOption={[
            {
              label: t("KICK_OFF_LIST_FILTER_QUOTE_KICK_OFF_STATUS_SITE_INFO"),
              value: 1,
            },
            {
              label: t(
                "KICK_OFF_LIST_FILTER_QUOTE_KICK_OFF_STATUS_PO_CONSISTENCY"
              ),
              value: 2,
            },
            {
              label: t(
                "KICK_OFF_LIST_FILTER_QUOTE_KICK_OFF_STATUS_SOLUTIONS_VALIDATION"
              ),
              value: 3,
            },
            {
              label: t(
                "KICK_OFF_LIST_FILTER_QUOTE_KICK_OFF_STATUS_OPERATIONS_ACCEPTANCE"
              ),
              value: 4,
            },
          ]}
          options={koStatusOptions}
          // eslint-disable-next-line react/destructuring-assignment
          column={filterProps.column}
        />
      ),
    },
    {
      Header: t("KICK_OFF_LIST_TABLE_PERSON_IN_CHARGE"),
      accessor: "admin_name",
      disableFilters: true,
    },
    {
      Header: t("ACTION"),
      accessor: "action",
      disableFilters: true,
    },
  ];

  useEffect(() => {
    const optionsLocal = [];
    for (const entry of Object.entries(QUOTE_STATUS_LIST)) {
      if (entry[1]) {
        optionsLocal.push({
          label: t(entry[1]),
          value: parseInt(entry[0], 10),
        });
      }
    }
    setKOOptions(optionsLocal);
  }, []);

  useEffect(() => {
    axios
      .get(`/general/personInChargeAdmin?countryId=${countryId}`)
      .then((response) => {
        const adminData = response.data.admins.map((admin) => {
          return {
            label: admin.name,
            value: admin.id,
          };
        });
        setAdminOptions(adminData);
      })
      .catch((error) => {});
  }, []);

  return (
    <section className="kick-off-list__container">
      <h2 className="kick-off-list__title">{t("KICK_OFF_LIST_TITLE")}</h2>

      <EnhancedTable
        type={TABLE_KICKOFF_LIST}
        columns={columns}
        dataURL={KICKOFF_LIST_ENDPOINT}
        initialPageSize={PAGE_SIZE}
        defaultSortOptions={[{ id: "start_date", desc: false, dir: "asc" }]}
        extraFilters={[
          {
            type: FILTER_TYPE_MULTI_SELECT_DROPDOWN,
            label: t("PERSON_IN_CHARGE"),
            placeholder: t("SEARCH"),
            name: "requestAdmin",
            labelClass: "kick-off-list__admins-list-label",
            containerClass: "kick-off-list__admins-list-dropdown-container",
            defaultOption: "Nothing Selected",
            options: adminOptions,
          },
        ]}
      />
    </section>
  );
};

KickOffList.propTypes = {
  t: PropTypes.func.isRequired,
};

KickOffList.defaultProps = {};

export default withTranslation()(KickOffList);
